// src/pages/Art.js
import React from 'react';
import { motion } from 'framer-motion';
import '../styles/Art.css';

// ایمپورت فایل‌ها
import artImage1 from '../assets/images/nftp1.jpg';
import artImage2 from '../assets/images/nftp2.jpg';
import artImage3 from '../assets/images/nftp3.jpg';
import artVideo1 from '../assets/images/nftv1.mp4';
import artVideo2 from '../assets/images/nftv2.mp4';
import artVideo3 from '../assets/images/nftv3.mp4';
import artVideo4 from '../assets/images/nftv4.mp4';
import artVideo5 from '../assets/images/nftv5.mp4';
import artVideo6 from '../assets/images/nftv6.mp4';
import artVideo7 from '../assets/images/nftv7.mp4';

function Art() {
  return (
    <motion.div
  className="art-page"
  initial={{ opacity: 0, scale: 0.9, rotate: -2 }} // ✅ کمی کوچک‌تر و چرخش جزئی
  animate={{ opacity: 1, scale: 1, rotate: 0 }}    // ✅ چرخش و بزرگ‌شدن به اندازه‌ی طبیعی
  transition={{ duration: 1, ease: "easeInOut" }} // ✅ حرکت نرم‌تر
>

      <h1>Art Gallery</h1>


      {/* ✅ بخش Mix Motion & Stage */}
      <section className="gallery-section">
        <h2>Mix Motion & Stage</h2>
        <div className="gallery">
        <motion.video
            src={artVideo2}
            autoPlay
            loop
            muted
            playsInline
            className="gallery-video"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2 }}
          />
          <motion.video
            src={artVideo3}
            autoPlay
            loop
            muted
            playsInline
            className="gallery-video"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2 }}
          />
          <motion.video
            src={artVideo4}
            autoPlay
            loop
            muted
            playsInline
            className="gallery-video"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2 }}
          />
          <motion.video
            src={artVideo5}
            autoPlay
            loop
            muted
            playsInline
            className="gallery-video"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2 }}
          />
        </div>
      </section>
      {/* ✅ بخش Motion */}
      <section className="gallery-section">
        <h2>Motion</h2>
        <div className="gallery">
          <motion.video
            src={artVideo1}
            autoPlay
            loop
            muted
            playsInline
            className="gallery-video"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2 }}
          />
          <motion.video
            src={artVideo6}
            autoPlay
            loop
            muted
            playsInline
            className="gallery-video"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2 }}
          />
          <motion.video
            src={artVideo7}
            autoPlay
            loop
            muted
            playsInline
            className="gallery-video"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2 }}
          />
        </div>
      </section>

      {/* ✅ بخش Stage */}
      <section className="gallery-section">
        <h2>Stage</h2>
        <div className="gallery">
          <motion.img
            src={artImage1}
            alt="Art 1"
            className="gallery-image"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2 }}
          />
          <motion.img
            src={artImage2}
            alt="Art 2"
            className="gallery-image"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2 }}
          />
          <motion.img
            src={artImage3}
            alt="Art 3"
            className="gallery-image"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2 }}
          />
        </div>
      </section>
    </motion.div>
  );
}

export default Art;
